var map = {
	"./en/example.yml": 158,
	"./en/hos.yml": 159,
	"./en/main.yml": 36,
	"./en/markdown.yml": 160,
	"./en/news.yml": 161,
	"./en/sfs.yml": 162,
	"./fr/example.yml": 163,
	"./fr/except.yml": 164,
	"./fr/framablog.yml": 165,
	"./fr/hos.yml": 166,
	"./fr/main.yml": 37,
	"./fr/news.yml": 167,
	"./fr/preamble.yml": 168,
	"./fr/risks_first.yml": 169,
	"./fr/risks_second.yml": 170,
	"./fr/sfs.yml": 171,
	"./fr/understand.yml": 172
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 157;